export default "__VITE_ASSET__BViSqZ2$__"